/**
 * JavaScript controller for shortcode: map
 */
Mmg.addShortcode('map', '.sc-map', (el, model, $, selector, className) => {

  // Widget Declarations
  const $this = $(el);
  const $canvas = $this.find(`${selector}__canvas`);
  const cardTemplate = $this.find(`${selector}__card-template`).html();

  const center = { lat: model.latitude, lng: model.longitude };
  const hasMarker = model.entity_type !== 'region';

  let mapPromise;
  let infoWindow;

  /**
   * Initialize the widget
   */
  (function init(){
    addEvents();
  })();

  /**
   * Handle UI events
   */
  function addEvents() {
    $this.on('vclick', showModal);
  }

  /**
   * Open the interactive map in a modal.
   */
  function showModal() {
    $canvas.removeClass('d-none');

    Mmg.Modal.show('Explore the map', $canvas, {
      shown: loadMap,
    });
  }

  /**
   * Download the maps library and render, at most once: the Maps API has no
   * destroy() method, so rebuilding would leak the old map.
   */
  function loadMap() {
    if (mapPromise) {
      return;
    }

    mapPromise = google.maps.importLibrary('maps')
      .then(loadMarkerLibrary)
      .then(renderMap);

    Promise.all([mapPromise, fetchMapData()])
      .then(([map, response]) => {
        if (response.boundary) {
          drawBoundary(map, response.boundary);
        }

        placeMarkers(map, response.schools || []);
      });
  }

  /**
   * Download the boundary and the schools pinned on the map.
   */
  function fetchMapData() {
    return $.getJSON(model.api_url, {
      entity_id: model.entity_id,
      entity_type: model.entity_type,
    });
  }

  /**
   * map-icons extends google.maps.Marker as it parses, so it loads after the
   * Maps libraries.
   */
  function loadMarkerLibrary() {
    if (hasMarker) {
      return $.getScript(model.map_dependents_url);
    }
  }

  /**
   * Render the map centered on the configured location.
   */
  function renderMap() {
    const map = new google.maps.Map($canvas[0], {
      center: center,
      zoom: model.zoom_level,
      scrollwheel: true,
      clickableIcons: false,
      disableDefaultUI: true,
      zoomControl: true,
      // Our markers stand in for Google's school pins.
      styles: [
        {
          featureType: 'poi.school',
          stylers: [{ visibility: 'off' }],
        },
      ],
    });

    return map;
  }

  /**
   * Pin the schools; a school page labels its own.
   */
  function placeMarkers(map, schools) {
    const isSchoolPage = model.entity_type === 'school';

    schools.forEach((school) => {
      if (isSchoolPage) {
        school.url = window.location.pathname;
      }

      const name = isSchoolPage ? school.name : '';
      const marker = createMarker(
        map,
        {
          lat: Number(school.latitude),
          lng: Number(school.longitude),
        },
        getMarkerIcon(name),
        school.name
      );

      marker.addListener('click', () => showCard(map, marker, school));
    });
  }

  /**
   * Place a marker whose look comes from our HTML: the Marker itself is an
   * invisible hit area over it.
   */
  function createMarker(map, position, icon, title) {
    return new Marker({
      map: map,
      position: position,
      title: title,
      icon: {
        url: 'https://maps.gstatic.com/mapfiles/transparent.png',
        scaledSize: new google.maps.Size(24, 24),
        anchor: new google.maps.Point(12, 24),
      },
      map_icon_label: icon.outerHTML,
    });
  }

  /**
   * Open the school's card over its marker.
   */
  function showCard(map, marker, school) {
    if (!infoWindow) {
      infoWindow = new google.maps.InfoWindow({ headerDisabled: true });

      map.addListener('click', () => infoWindow.close());
    }

    infoWindow.setContent(Mustache.render(cardTemplate, school));
    infoWindow.open({
      map: map,
      anchor: marker,
    });
  }

  /**
   * Build the pin: the school icon, with its name beside it when given.
   */
  function getMarkerIcon(name) {
    const icon = document.createElement('div');

    icon.className = `${className}__marker ${className}__marker--school`;

    if (name) {
      const label = document.createElement('span');

      label.className = `${className}__marker-label`;
      label.textContent = name;
      icon.append(label);
    }

    return icon;
  }

  /**
   * Outline the region.
   */
  function drawBoundary(map, geometry) {
    map.data.addGeoJson({
      type: 'Feature',
      properties: {},
      geometry: geometry,
    });

    map.data.setStyle({ clickable: false });
  }
});
